
import { gql } from "@apollo/client";

export const GET_SYSTEM_INFO = gql`
query Info($domain: String!, $input: BasicQueryInfoInput!) {
  system {
    info(domain: $domain, input: $input) {
      system_id
      fk_system_types
      name
      default_amount
      min_feed_speed
      max_feed_speed
    }
  }
}
`

export interface System {
  systemId: number;
  systemType: number;
  name: string; 
  default_amount: number;
  min_feed_speed: number;
  max_feed_speed: number;
}

export interface SystemsResponse {
  system: {
    info: System[]
  }
}